import React from 'react';
import { RatingBox, RatingHeading, RatingImages, RatingText } from './rating.styled';
import StarIcons from '@assets/images/star-icons-fallback.png';
import SocialPeople from '@assets/images/social-people-fallback.png';

interface RatingProps {
	ratingIcon?: string;
	socialPeopleImage?: string;
	consumerReview?: string;
	testedApproved?: string;
}

const Rating: React.FC<RatingProps> = ({ ratingIcon, socialPeopleImage, consumerReview, testedApproved }) => {
	return (
		<RatingBox>
			<RatingHeading>{testedApproved}</RatingHeading>
			<RatingImages>
				<img src={socialPeopleImage || SocialPeople} alt="Social Image" />
				<img src={ratingIcon || StarIcons} alt="Rating" />
			</RatingImages>
			<RatingText>{consumerReview}</RatingText>
		</RatingBox>
	);
};

export default Rating;
